
























import {Vue, Component, Prop} from 'vue-property-decorator';
import AppLink from './AppLink.vue';

@Component({
    name: 'TimelineBlock',
    components: {AppLink},
})
export default class TimelineBlock extends Vue {
    @Prop({required: true}) public title!: string;
    @Prop({required: true}) public companyName!: string;
    @Prop({required: true}) public companyHref!: string;
    @Prop({required: true}) public dateString!: string;
    @Prop({default: 'left'}) public side!: string;
    @Prop({default: () => ['fas', 'briefcase']}) public faIcon!: [];
}
